import { render } from "./BlueCard.vue?vue&type=template&id=529e2220"
import script from "./BlueCard.vue?vue&type=script&lang=js"
export * from "./BlueCard.vue?vue&type=script&lang=js"

import "./BlueCard.vue?vue&type=style&index=0&id=529e2220&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__